import { HTTP_STATUSES } from "@miplatform/constants";
import { ISeriesGroupResponse } from "@miplatform/types";
import { useSeriesGroup } from "@mibuildweb/hooks";

export const useAddSeriesGroupModalViewModel = ({
  setRefresh,
  handleCloseModal,
}: {
  setRefresh: (updater: (prev: boolean) => boolean) => void;
  handleCloseModal: () => void;
}) => {
  const { isLoading, createSeriesGroup, updateSeriesGroup } = useSeriesGroup();

  const handleCreateSeriesGroup = async (
    data: Omit<ISeriesGroupResponse, "id">
  ) => {
    const response = await createSeriesGroup(data);
    if (response.status === HTTP_STATUSES.OK) {
      handleCloseModal();
      setRefresh((prev) => !prev);
    }
  };

  const handleUpdateSeriesGroup = async (
    data: Partial<ISeriesGroupResponse>
  ) => {
    const response = await updateSeriesGroup(data);
    if (response.status === HTTP_STATUSES.OK) {
      handleCloseModal();
      setRefresh((prev) => !prev);
    }
  };

  return {
    isLoading,
    handleCreateSeriesGroup,
    handleUpdateSeriesGroup,
  };
};
